export const initialState = {
  loading: false,
  suggestions: [],
  error: undefined,
};

export default initialState;



// WEBPACK FOOTER //
// ./AutoComplete/context/initialState.js